module.exports = __webpack_public_path__ + "img/HL-Logo.3c9d5fc2.png";